import Immutable from 'immutable';

/**
 * Checks whether the object is an Immutable object
 * @param object - Plain JS Object or its Immutable version
 */
export function isImmutable<T>(object: T | DeepIMap<T>): object is DeepIMap<T> {
  return Immutable.isImmutable(object);
}
